<div class="export-modal preview-modal">
  <!-- header -->
  <div class="modal-header start ps-24px">
    <div class="export-modal-header">
      <h5>Preview selection</h5>
      <p class="sub">This {{contextLabel}} will be added to the plan</p>
    </div>

    <button
      type="button"
      class="close-btn"
      aria-label="Close"
      (click)="modalRef.hide()"
      pTooltip="Close"
      tooltipPosition="left">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <!-- body -->
  <div class="modal-body">
    <section class="preview-card">
      <div class="table-scroll" *ngIf="data.contextLabel == 'Assets'">
        <p-table [value]="selection" [paginator]="false" [responsiveLayout]="'scroll'" [rowHover]="false">
          <ng-template pTemplate="header">
            <tr>
              <th class="col-3">Name</th>
              <th>Serial No.</th>
              <th>Type</th>
              <th>Status</th>
              <th>Created date</th>
            </tr>
            <tr class="rule"><td colspan="4"></td></tr>
          </ng-template>

          <ng-template pTemplate="body" let-asset>
            <tr>
              <td class="w-20rem">{{ asset.name }}</td>
              <td>{{ asset.serialNo ? asset.serialNo : '-' }}</td>
              <td>{{ asset.assetType?.name }}</td>
              <td>
                <span
                  class="p-mr-2 p-tag p-component" [ngStyle]="{'background': asset?.assetStatus?.colorCode ? asset.assetStatus.colorCode + '50' : '#cccccc'}">
                  
                  <span class="p-tag-value text-dark">{{asset?.assetStatus?.label}}</span>
                </span>
                </td>
              <td>{{asset?.createdDate | momentDate : ' hh:mm a' :  timezone}},&nbsp;{{asset?.createdDate | momentDate : dateFormat : timezone}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="table-scroll" *ngIf="data.contextLabel == 'Sites'">
        <p-table [value]="selection" [paginator]="false" [responsiveLayout]="'scroll'" [rowHover]="false">
          <ng-template pTemplate="header">
            <tr>
              <th class="col-3">{{translate?.site.fields.name.singular}}</th>
              <th>{{translate?.site.fields.type.singular}}</th>
              <!-- <th>{{translate?.site.fields.status.singular}}</th> -->
              <th>Created date</th>
            </tr>
            <tr class="rule"><td colspan="4"></td></tr>
          </ng-template>

          <ng-template pTemplate="body" let-site>
            <tr>
              <td class="w-20rem">{{ site.siteName }}</td>
              <td>{{ site.type ? site.type.name : '-' }}</td>
              <!-- <td>
                <span class="p-mr-2 p-tag-success p-tag p-component" id="value_SiteStatusActive" *ngIf="site?.siteStatus?.active"><span class="p-tag-value">{{translate?.general.status.active.singular}}</span></span>

                <span class="p-mr-2 p-tag p-component p-tag-danger" id="value_SiteStatusInactive" *ngIf="!site?.siteStatus?.active"><span class="p-tag-value text-dark">{{translate?.general.status.inactive.singular}}</span></span>
                </td> -->
              <td>{{site?.createdDate | momentDate : ' hh:mm a' :  timezone}},&nbsp;{{site?.createdDate | momentDate : dateFormat : timezone}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </section>
  </div>

  <!-- footer -->
  <div class="modal-footer justify-between">
    <div class="left-indicator">
      <span class="ok-dot"><i class="fa-regular fa-check"></i></span>
      <span class="text">{{ selection?.length || 0 }} {{ contextLabel }} will be added</span>
    </div>

    <div class="right-actions">
      <button type="button" class="custella-btn-white" (click)="onBack()">Back</button>
      <p-button icon="fa-regular fa-check" label="Confirm & Add" (onClick)="confirmAdd()"></p-button>
    </div>
  </div>
</div>
